var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.74 18.288l-2.598-2.56c-.62-.612-.731-1.555-.295-2.317a8.247 8.247 0 0 0 1.007-5.255c-.511-3.71-3.57-6.687-7.34-7.138C5.405.407.975 4.288.955 9.285c-.018 4.415 3.58 8.161 8.06 8.383a8.59 8.59 0 0 0 4.29-.9c.758-.382 1.666-.258 2.26.33l2.683 2.643c.41.406 1.08.406 1.492 0a1.015 1.015 0 0 0 0-1.453zm.67 2.133a2.022 2.022 0 0 1-2.834 0l-2.682-2.644c-.297-.294-.762-.357-1.161-.157a9.546 9.546 0 0 1-4.767 1.001C3.981 18.375-.02 14.21 0 9.281c.022-5.57 4.952-9.89 10.628-9.21 4.2.501 7.6 3.813 8.172 7.955a9.201 9.201 0 0 1-1.125 5.859c-.224.393-.169.861.137 1.163l2.597 2.56a1.97 1.97 0 0 1 0 2.813z","id":"path-1"}));
}

Search.displayName = "Search";

Search.defaultProps = {"viewBox":"0 0 21 21"};

module.exports = Search;

Search.default = Search;
